import { useQuery } from "@tanstack/react-query"

import { getLot, listLots } from "@/features/lots/api/lots.api"
import type { GetLotOptions } from "@/features/lots/api/lots.api"
import type { ListLotsParams } from "@/features/lots/api/types"

export const lotKeys = {
  all: ["lots"] as const,
  list: (params: ListLotsParams) =>
    ["lots", "list", params ?? {}] as const,
  // The detail key includes the option flags so includeLoads=true and
  // the default payload don't share a cache slot — otherwise an early
  // hover would pin the smaller shape and the composition card would
  // render empty.
  // Prefix used for invalidation — matches every variant of detail()
  // regardless of the options object passed at fetch time.
  details: (id: string | number) => ["lots", "detail", String(id)] as const,
  detail: (id: string | number, opts: GetLotOptions = {}) =>
    ["lots", "detail", String(id), opts] as const,
}

export function useLots(params: ListLotsParams = {}) {
  return useQuery({
    queryKey: lotKeys.list(params),
    queryFn: () => listLots(params),
  })
}

export function useLot(
  lotId: string | number | undefined,
  opts: GetLotOptions = {},
) {
  return useQuery({
    queryKey: lotKeys.detail(lotId ?? "", opts),
    queryFn: () => getLot(lotId as string | number, opts),
    enabled: !!lotId,
  })
}
